import { useState } from 'react'
import SubmissionsTable from './components/SubmissionsTable'
import FileUpload from './components/FileUpload'
import SignAgreement from './components/SignAgreement'
import { BulkSubmissionProvider, useBulkSubmissions } from './BulkSubmissionContext'

const BulkSubmissions = () => {
  return (
    <BulkSubmissionProvider>
      <div className='p-6 w-full'>
        <BulkSubmissionSteps />
      </div>
    </BulkSubmissionProvider>
  )
}

const BulkSubmissionSteps = () => {
  const { step } = useBulkSubmissions()

  switch (step) {
    case 0:
      return <SubmissionsTable />
    case 1:
      return <FileUpload />
    case 2:
      return <SignAgreement />

    default:
      return <SubmissionsTable />
  }
}

export default BulkSubmissions
